// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import FaroeIslands from '../_raw/flag/icon_flag_faroe_islands.png';

export default () => <img src={FaroeIslands} alt="FaroeIslands" />;
